<div class="md-select-custom not-placeholder">
  <label *ngIf="label != null">{{label}}</label>
  <mat-select [(ngModel)]="value" name="value">
    <mat-option [value]="p" *ngFor="let p of parcelas" (click)="clickValue(p)"> 
      {{p}}
    </mat-option>
  </mat-select>
</div>
